import { Design } from '../../../types';

type IntentHierarchyTree = {
  children: IntentHierarchyTree[];
  id: string;
  parents: IntentHierarchyTree[];
  title: string;
};

export function createIntentHierarchyTree(
  design: Design
): IntentHierarchyTree[] {
  const { features } = design.rootSettings;
  const intentIds = design.globalIntents.map(({ intent }) => {
    return intent;
  });
  const intentsMap = new Map(
    design.components.intents.map((intent) => {
      return [intent.id, intent];
    })
  );

  const treeItems = intentIds.map((intentId): IntentHierarchyTree | null => {
    const intent = intentsMap.get(intentId);
    if (!intent) {
      return null;
    }

    return {
      children: [],
      id: intent.id,
      parents: [],
      title: intent.name
    };
  }).filter((treeItem) => {
    return treeItem != null;
  }) as IntentHierarchyTree[];

  const treeItemsMap = new Map(
    treeItems.map((treeItem) => {
      return [treeItem.id, treeItem];
    })
  );
  treeItems.forEach((treeItem) => {
    const intent = intentsMap.get(treeItem.id)!;
    const {
      childIntents,
      children,
      parentIntent,
      parents
    } = intent.props.config;
    if (features.intentManagement) {
      treeItem.children = children.map(({ customId }) => {
        return treeItemsMap.get(customId)!;
      });
      treeItem.parents = parents.map(({ customId }) => {
        return treeItemsMap.get(customId)!;
      });
    } else {
      treeItem.children = childIntents?.map((childId) => {
        return treeItemsMap.get(childId)!;
      }) ?? [];
      treeItem.parents = (!parentIntent) ? [] : (
        [treeItemsMap.get(parentIntent)!]
      );
    }
  });

  return treeItems.filter((treeItem) => {
    return !treeItem.parents.length;
  }).sort(function (a, b) {
    return a.title.localeCompare(b.title);
  });
}
